import { useNavigate } from "react-router-dom";
import { KeyRound, GitBranch, Calculator, FileText, Monitor, Layers, Activity, Lock, Play } from "lucide-react";

const ICONS = {
  "key-round": KeyRound,
  "git-branch": GitBranch,
  "calculator": Calculator,
  "file-text": FileText,
  "monitor": Monitor,
  "layers": Layers,
  "activity": Activity,
  "play": Play,
};

const COLORS = {
  green: "bg-envicom-green/15 text-envicom-green border-envicom-green/30",
  blue: "bg-envicom-blue/15 text-envicom-blue border-envicom-blue/30",
  purple: "bg-envicom-purple/15 text-envicom-purple border-envicom-purple/30",
  teal: "bg-envicom-teal/15 text-envicom-teal border-envicom-teal/30",
  orange: "bg-envicom-orange/15 text-envicom-orange border-envicom-orange/30",
};

export default function AppCard({ app, locked = false }) {
  const navigate = useNavigate();
  const Icon = ICONS[app.icon] || KeyRound;
  const colorClass = COLORS[app.color] || COLORS.blue;

  const onClick = () => {
    if (locked) return;
    navigate(app.route);
  };

  return (
    <button
      type="button"
      data-testid={`app-card-${app.id}`}
      onClick={onClick}
      disabled={locked}
      className={`group text-left bg-envicom-surface border border-envicom-border rounded-md p-6 transition-all duration-200 flex flex-col items-start
        ${locked ? "opacity-50 cursor-not-allowed" : "hover:-translate-y-1 hover:border-envicom-borderHover hover:shadow-[0_8px_30px_rgba(14,165,233,0.06)] cursor-pointer"}`}
    >
      <div className={`w-12 h-12 rounded flex items-center justify-center mb-5 border ${colorClass}`}>
        <Icon className="w-6 h-6" strokeWidth={2} />
      </div>
      <div className="flex items-center gap-2 mb-2">
        <h3 className="font-mono font-bold text-base text-envicom-text tracking-tight">{app.name}</h3>
        {locked && <Lock className="w-3.5 h-3.5 text-envicom-muted" />}
        {!locked && app.access === "r" && (
          <span className="text-[9px] font-mono px-1.5 py-0.5 rounded border border-envicom-border text-envicom-muted uppercase tracking-wider">
            Read
          </span>
        )}
      </div>
      <p className="text-envicom-muted text-sm leading-relaxed">{app.description}</p>
    </button>
  );
}
